export default __webpack_public_path__ + "static/media/pic6.b8b17d6b.jpg";